import styled, { css } from 'styled-components';
import { rem } from 'polished';
import Icon from '../Icon';
import mediaqueries from '../../../config/themes/variables/mediaqueries';

const StyledGeneralList = styled.ul`
  background-color: ${props => props.theme.colors.grayMoreLight};
  border-left: 1px solid ${props => props.theme.colors.grayLighter};
  border-right: 1px solid ${props => props.theme.colors.grayLighter};
  border-top: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  margin: 0;
  padding: 0;
  width: 100%;
`;

const StyledItem = styled.li`
  background-color: ${props => props.theme.colors.grayMoreLight};
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  font: ${rem('14px')} / ${rem('14px')} ${props => props.theme.fonts.book};
  overflow: hidden;
  padding: ${rem('5px')} ${rem('20px')};
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  min-height: ${rem('50px')};
  &:before {
    display: none;
  }
`;

const StyledItemNoBorder = styled(StyledItem)`
  border-bottom: 0;
  font: ${rem('16px')} / ${rem('16px')} ${props => props.theme.fonts.bold};
  text-transform: uppercase;
`;

const StyledSpan = styled.span`
  flex-grow: 1;
  font-family: inherit;
  font: ${rem('14px')} / ${rem('14px')} ${props => props.theme.fonts.book};
`;

const StyledIconShare = styled(Icon)`
  align-items: center;
  display: ${props => (props.active ? css`flex` : css`none`)};
  margin-left: ${rem('10px')};
  ${props => (props.active ? css`block` : css`none`)};
  ${mediaqueries.greaterThan('mobile')`
      display: block;
  `};
  ${props =>
    props.active &&
    css`
      fill: ${props => props.theme.colors.light};
    `};
`;

const StyledIconNav = styled(Icon)`
  background: none;
  border: none;
  margin-left: ${rem('20px')};
  float: right;
  width: ${rem('24px')};
  height: ${rem('21px')};
`;

const StyledIconNavPlata = styled(Icon)`
  background: none;
  border: none;
  margin-left: ${rem('20px')};
  width: ${rem('24px')};
  height: ${rem('21px')};
  margin-top: ${rem('9px')};

  ${mediaqueries.lessThan('mobile')`
    margin-top: ${rem('5px')};
    width: ${rem('20px')};
    height: ${rem('17px')};
  `};
`;

const StyledWrapper = styled.div`
  align-items: center;
  display: flex;
  padding: ${rem('8px')} 0;
  right: 0;
  top: ${rem('0px')};
  transition: 0.5s;
  fill: ${props => props.theme.colors.dark};
  ${mediaqueries.greaterThan('mobile')`
      top: 0;
  `};
`;

export {
  StyledGeneralList,
  StyledItem,
  StyledSpan,
  StyledIconShare,
  StyledIconNav,
  StyledIconNavPlata,
  StyledWrapper,
  StyledItemNoBorder
};
